export const heroes = ['Alice', 'Bob', 'Charlie', 'David', 'Eva', 'Frank', 'Grace', 'Harry', 'Ivy', 'Jack']
export const places = [
  'Wonderland',
  'Neverland',
  'Hogwarts',
  'Narnia',
  'Middle Earth',
  'Camelot',
  'Atlantis',
  'Oz',
  'Underworld',
  'Heaven'
]
export const characters = ['Rabbit', 'Fairy', 'Wizard', 'Lion', 'Elf', 'Knight', 'Mermaid', 'Witch', 'Ghost', 'Angel']
export const objects = [
  'Mirror',
  'Lamp',
  'Ring',
  'Sword',
  'Map',
  'Key',
  'Book',
  'Crystal Ball',
  'Potion',
  'Treasure Chest'
]
export const subjects = [
  'Friendship',
  'Adventure',
  'Courage',
  'Kindness',
  'Exploration',
  'Magic',
  'Nature',
  'Dreams',
  'Discovery',
  'Love'
]
export const ages = ['3-4', '5-6', '7-8', '9-10', '11-12', '13-14', '15-16', '17-18']
export const writingStyles = [
  'Humorous',
  'Serious',
  'Poetic',
  'Mysterious',
  'Whimsical',
  'Suspenseful',
  'Adventurous',
  'Magical',
  'Thought-provoking',
  'Epic'
]
